import { useEffect, useState } from "react";
import { Card, Button, Flex } from "antd";
import { DrawingModes } from "../ThreeJs/Global/variables";
import { sceneManager } from "../ThreeJs/SetUps/SceneManager";
import { removeLineMeshes, cleanUp } from "../ThreeJs/Global/functions";

const TrimSegment = ({ currentDrawingMode, updateDrawingMode }) => {
  const [buttonText, setButtonText] = useState("Draw Trim Segment");
  const [buttonStyle, setButtonStyle] = useState("primary");

  useEffect(() => {
    if (currentDrawingMode === DrawingModes.TRIM) {
      setButtonText("Cancel Trim");
      setButtonStyle("danger");
    } else {
      setButtonText("Draw Trim Segment");
      setButtonStyle("primary");
    }
  }, [currentDrawingMode]);

  const handleClick = () => {
    if (currentDrawingMode === DrawingModes.TRIM) {
      updateDrawingMode(DrawingModes.NONE);
      removeLineMeshes(sceneManager.scene); // cleanup preview lines
      cleanUp();
    } else {
      updateDrawingMode(DrawingModes.TRIM);
    }
  };

  const handleTrim = () => {
    // When polygon is closed, trigger trim action in ThreeJs/Trim
    // import("../ThreeJs/Trim/trimFunctions").then(({ applyTrim }) => {
    //   applyTrim(sceneManager.scene);
    // });
    // updateDrawingMode(DrawingModes.NONE);
  };

  return (
    <Card style={{ borderRadius: 8, width: "275px" }} bodyStyle={{ padding: 16 }}>
      <Flex vertical>
        <Button
          block
          type={buttonStyle}
          danger={buttonStyle === "danger"}
          onClick={handleClick}
        >
          {buttonText}
        </Button>
        {currentDrawingMode === DrawingModes.TRIM && (
          <Button block type="primary" style={{ marginTop: 8 }} onClick={handleTrim}>
            Trim
          </Button>
        )}
      </Flex>
    </Card>
  );
};

export default TrimSegment;
